import React, { useRef, useEffect, useState, useCallback } from "react";
import "./style.css";

const WORDS = ["Inspiră", "Pauză", "Expiră", "Pauză", "Zâmbește", "Repetă"];
const INTERVAL_MS = 2800;  // gap between words
const TRAVEL_MS = 14000;   // time for one item to cross the screen

const BreathBanner = () => {
  const bannerRef = useRef(null);
  const [isActive, setIsActive] = useState(false);
  const [flyingItems, setFlyingItems] = useState([]);
  const wordIndexRef = useRef(0);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setIsActive(true);
      },
      { threshold: 0.3 }
    );
    if (bannerRef.current) observer.observe(bannerRef.current);
    return () => observer.disconnect();
  }, []);

  const launch = useCallback(() => {
    const word = WORDS[wordIndexRef.current % WORDS.length];
    wordIndexRef.current += 1;
    const wordId = Date.now() + Math.random();

    // Launch the word
    setFlyingItems((prev) => [...prev, { text: word, id: wordId, isSep: false }]);
    setTimeout(() => {
      setFlyingItems((prev) => prev.filter((w) => w.id !== wordId));
    }, TRAVEL_MS + 500);

    // Launch a single ✦ exactly halfway between this word and the next
    const sepId = wordId + 0.001;
    setTimeout(() => {
      setFlyingItems((prev) => [...prev, { text: "✦", id: sepId, isSep: true }]);
      setTimeout(() => {
        setFlyingItems((prev) => prev.filter((w) => w.id !== sepId));
      }, TRAVEL_MS + 500);
    }, INTERVAL_MS / 2);
  }, []);

  useEffect(() => {
    if (!isActive) return;

    launch(); // first word immediately
    const interval = setInterval(launch, INTERVAL_MS);
    return () => clearInterval(interval);
  }, [isActive, launch]);

  return (
    <section className="breath-banner" ref={bannerRef}>
      {flyingItems.map(({ text, id, isSep }) => (
        <span
          key={id}
          className={isSep ? "breath-banner__sep-item" : "breath-banner__word"}
        >
          {text}
        </span>
      ))}
    </section>
  );
};

export default BreathBanner;
